import { Button } from "@mui/material";
import DateInput from "components/Input/DateInput";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../helpers";
import { appSetFromDate, appSetToDate } from "../../store/actions/appAction";
import dayjs from "dayjs";
import { store } from "store/store";

export function DateToString(date?: number | Date) {
    const { getState } = store
    const business = getState().businessReducer.business?.business;
    const isGregorian = business?.is_gregorian;
    if (!date) return "";
    if (isGregorian) {
        return dayjs().format("YYYY/MM/DD");
    }
    return Intl.DateTimeFormat("fa-IR-u-nu-latn", { dateStyle: "short" }).format(date);
}

export interface DateFilterProps {
    onSubmit: ({ from, to }: { from: any; to: any }) => void;
}

export default function DateFilter({ onSubmit }: DateFilterProps) {
    const dispatch = useDispatch();

    const fromDate = useSelector((state: any) => state.appReducer.fromDate);
    const toDate = useSelector((state: any) => state.appReducer.toDate);

    const setFromDate = (fromDate: any) => dispatch(appSetFromDate(fromDate));
    const setToDate = (toDate: any) => dispatch(appSetToDate(toDate));

    function handleChange(date: any, name: any) {
        if (name === "from") {
            setFromDate(date);
        }
        if (name === "to") {
            setToDate(date);
        }
    }

    function handleSubmit() {
        onSubmit({ from: fromDate, to: toDate });
    }

    return (
        <div
            style={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "24px 16px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    alignItems: "end",
                }}
            >
                <div style={{ width: "128px" }}>
                    <DateInput
                        label="از تاریخ"
                        name="from"
                        defaultValue={fromDate ? formatDate(fromDate) : null}
                        onchange={handleChange}
                    />
                </div>
                <div style={{ width: "128px" }}>
                    <DateInput
                        label="تا تاریخ"
                        name="to"
                        defaultValue={toDate ? formatDate(toDate) : null}
                        onchange={handleChange}
                    />
                </div>
                <Button variant="contained" color="primary" onClick={handleSubmit} style={{ height: "40px" }}>
                    اعمال فیلتر
                </Button>
            </div>
        </div>
    );
}
